enum Background {
  BEACH = '1',
  CITY = '2',
  COUNTRYSIDE = '3',
  MOUNTAINS = '4',
  NATURE = '5',
  NIGHTLIFE = '6',
  SKI = '7',
  SKY = '8',
  SNOW = '9',
  ACTIVITIES = '10',
  CARS = '11',
  CRUISE = '12',
  FLIGHTS = '13',
  HOTELS = '14',
  PACKAGES = '15',
  COLOR = '17',
}

export { Background };
